export const statusColorMapping = {
  created: "darkyellow",
  started: "green",
  ended: "red"
};
